angular.module('unica_invitation.invitation_controllers')

.controller('InvitationEditController', function(
	$rootScope, $scope, $state, $stateParams,
	FileUploader, getBaseApiURL, Session,
	InvitationEditService
) {

	$scope.event_id           = $stateParams.event_id;
	$scope.invitation_list_id = $stateParams.invitation_list_id;
	$scope.id                 = $stateParams.id;
	$scope.isReadonly         = false;
	$scope.disableSubmit      = false;

	$scope.preselections = [];


	$rootScope.getEvent( $stateParams.event_id );
	$rootScope.getEventFields( $stateParams.event_id );

	$rootScope.getInvitationById($stateParams.id);

	// $scope.$on( 'event_field_loaded', function() {
	// 	console.log($rootScope.eventFieldData);
	// });

	$scope.uploader =  new FileUploader({
		removeAfterUpload: true,
		url: getBaseApiURL + '/invitation/update-file-field',
		headers: {
			Authorization : 'Bearer ' + Session.token,
			Accept: 'application/json'
		}
	});

	$scope.uploaderQueue = [];

	$scope.uploader.onAfterAddingAll = function(addedFileItems) {
		// console.log('onAfterAddingAll');
		// console.log(addedFileItems);

		angular.forEach(addedFileItems, function(el) {
			if ( $scope.uploaderQueue[el.alias] ) {
				$scope.uploaderQueue[el.alias].remove();
			}

			$scope.uploaderQueue[el.alias] = el;
			$rootScope.registrationData[ 'filename_' + el.alias ] = el.file.name;
			$rootScope.registrationData[ el.alias ] = el.file.name;
		});

		// console.log( $scope.uploaderQueue );
	};


	$scope.uploader.onTimeoutItem = function(timeoutItem) {
		// console.log('timeout item');
		// console.log(timeoutItem);

		$scope.hideLoader();

		if ( uploadErrors ) {
			$scope.showErrorMsg('Timeout durante il caricamento');
		}

		setTimeout(function() {
			location.reload();
		}, 2000);
	}


	$scope.uploader.onCompleteAll = function() {
		$scope.hideLoader();

		// console.log('complete all');
		// console.log(uploadErrors);
		//
		// console.log('obj uploader');
		// console.log($scope.uploader);


		if ( uploadErrors ) {
			$scope.showErrorMsg(errorMessage);
		} else {
			$scope.showSuccessMsg('Registrazione avvenuta con successo!', '');
		}

		setTimeout(function() {
			location.reload();
		}, 2000);
	};


	var uploadErrors = false;
	var errorMessage = false;
	$scope.uploader.onErrorItem = function( item, response, status, headers ) {
		// console.log('error item');
		// console.log(response);

		uploadErrors = uploadErrors || true;
		if ( response && response.message ) {
			errorMessage = response.message;
		} else {
			errorMessage = 'Errore durante il caricamento del file'
		}
	}

	$scope.uploader.onSuccessItem = function( item, response, status, headers ) {
		// console.log('success item');
		// console.log(response);

		if ( response && response.result == 'ko' ) {
			uploadErrors = uploadErrors || true;
			errorMessage = response.message;
		}
	}

	$scope.clearEventFieldFile = function( eventFieldName ) {
		angular.element(document.querySelector(eventFieldName)).val(null);
		$scope.uploader.removeFromQueue( $scope.uploaderQueue[eventFieldName] );
		$rootScope.registrationData[ 'filename_' + eventFieldName ] = null;
	};


	$scope.$on( 'invitation_loaded', function() {
		console.log($rootScope.userData);

		if ( $rootScope.invitationData.status == 'confirmed' ) {
			$scope.confirmPartecipation = 'yes';
		}
		$scope.airportTransferTypeChange();

		$scope.showPremio2021 = [
			44,
			194,
			195,
			196,
			197,
			198,
			199,
			200,
			201,
			202,
			203,
			204,
			205,
			206,
			207
		].includes( $rootScope.eventData.id );

		$scope.showPremio2022 = [
			313,
			312,
			311,
			310,
			309,
			317
		].includes( $rootScope.eventData.id );

		$scope.showOrologio2021 = [
			45,
			194,
			200,
			205,
			206
		].includes( $rootScope.eventData.id );

		$scope.showPrivacyGare2019 = [
			45,
			194,
			200,
			207,
			206,
			205,
			204,
			203,
			202,
			201
		].includes( $rootScope.eventData.id );

		$scope.hidePrivacyMedia = [
			430
		].includes( $rootScope.eventData.id );

	});

	function parseRegistrationFromDateToTimestamp(data) {
		angular.forEach(data, function(d, key) {
			if ( key == 'dob' ||
				key == 'doc_emission_date' || key == 'doc_expiration_date' ||
				key == 'data_partenza' || key == 'data_ritorno' ) {
				data[key] = moment( data[key] ).format('YYYY-MM-DD');
			}

			if ( key == 'ora_partenza_andata' || key == 'ora_arrivo_andata' ||
				key == 'ora_partenza_ritorno' || key == 'ora_arrivo_ritorno' ) {
				data[key] = moment( data[key] ).format('HH:mm:ss');
			}
		});
		return data;
	}


	$scope.checkCondition = function( conditions ) {
		if ( !conditions || conditions.length == 0 || !$rootScope.registrationData ) return true;

		var check = false;

		angular.forEach(conditions, function(condition, key) {
			if ( condition.compare == '=' && $rootScope.registrationData[condition.field] instanceof Array &&
				$scope.parseCompared( $rootScope.registrationData[condition.field] ).includes($scope.parseCompared( condition.value ))  )
			{
				check = true;
			}
			else if ( condition.compare == '=' &&
				$scope.parseCompared( $rootScope.registrationData[condition.field] ) == $scope.parseCompared( condition.value ) )
			{
				check = true;
			}
			else if ( condition.compare == '<>' && $rootScope.registrationData[condition.field] != condition.value ) {
				check = true;
			}
			else if ( condition.compare == '<' && $rootScope.registrationData[condition.field] < condition.value ) {
				check = true;
			}
			else if ( condition.compare == '>' && $rootScope.registrationData[condition.field] > condition.value ) {
				check = true;
			}
		});

		return check;
	}


	$scope.parseCompared = function ( string ) {
		if ( string instanceof Array ) {
			angular.forEach(string, function(s, key) {
				string[key] = $scope.parseCompared(s);
			});
		}
		else if ( string === string + '' ) {
			string = string.toLowerCase();
			string = string.replace('ì', 'i');
			string = string.replace('ò', 'o');
			string = string.replace('ù', 'u');
			string = string.replace('à', 'a');
			string = string.replace('è', 'e');
			string = string.replace('é', 'e');
		}

		return string;
	}


	// $scope.changeEventFieldFile = function( el )
	// {
	// 	var nameChanged = el.getAttribute('id') + '_changed';
	// 	$rootScope.registrationData[ nameChanged ] = true;
	// 	$scope.uploader.formData.push({ nameChanged: true });
	// };

	$scope.removeEventFieldFile = function()
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare il programma dell\'evento dal sito?',
			text: 'Confermi la cancellazione?'
		}).then(function() {

			// $scope.showLoader();
			//
			// EventSiteService
			// 	.deleteEventProgram( $stateParams.event_id  )
			// 	.then(function(data) {
			// 		$scope.hideLoader();
			//
			// 		if ( data ) {
			// 			$rootScope.eventData.program = null;
			//
			// 			$scope.showSuccessMsg('Programma eliminato con successo!', '');
			// 		}
			// 	});

		}, function() { });
	};

	function saveInvitation() {
		// $scope.showLoader();
		$scope.disableSubmit      = true;
		
		$rootScope.registrationData.hash = $rootScope.invitationData.hash;

		var registrationData = angular.copy($rootScope.registrationData);
		registrationData = parseRegistrationFromDateToTimestamp(registrationData);

		if ( registrationData.avatar && registrationData.avatar.dataURL ) {
			registrationData.avatar = registrationData.avatar.dataURL;
		}
		if ( registrationData.avatar_2 && registrationData.avatar_2.dataURL ) {
			registrationData.avatar_2 = registrationData.avatar_2.dataURL;
		}

		angular.forEach($rootScope.eventFieldData, function(eventField, key) {
			if ( eventField.type == 'image' && registrationData[ eventField.name ] && registrationData[ eventField.name ].dataURL ) {
				// console.log(registrationData);
				registrationData[ eventField.name ] = registrationData[ eventField.name ].dataURL;
			}
		});

		if ( [ 437, 438, 439 ].includes( $rootScope.eventData.id )  ) {
			registrationData['privacy'] = 1;
			registrationData['privacy_media'] = 1;
		}

		// console.log(registrationData);return;

		InvitationEditService
			.update(registrationData)
			.then(function(invitation) {
				$scope.hideLoader();

				if ( invitation ) {

					if ( invitation.id == $stateParams.id ) {

						if ( $scope.uploader.queue.length > 0 ) {

							for ( var i = 0; i < $scope.uploader.queue.length; i++ ) {
								$scope.uploader.queue[i].formData.push({ 'id' : invitation.id });
							}
							// $scope.uploader.queue[0].formData.push({ 'id' : invitation.id });
							// $scope.uploader.formData.push({ 'id' : invitation.id });

							$scope.showLoader();
							$scope.uploader.uploadAll();
						} else {
							$scope.showSuccessMsg('Invito aggiornato con successo!', '');

							setTimeout(function() {
								location.reload();
							}, 1000);
						}

					} else {
						$state.go('app.invitation.list', { event_id: $stateParams.event_id, invitation_list_id: $stateParams.invitation_list_id });
					}
				}
			});
	}


	$scope.removeAvatarImage = function() {
		$rootScope.registrationData.avatar = null;
	}

	$scope.removeAvatar2Image = function() {
		$rootScope.registrationData.avatar_2 = null;
	}


	$scope.removeFieldImage = function( eventFieldName ) {
		$rootScope.registrationData[ eventFieldName ] = null;
	}


	$rootScope.transferAirportPlaceLabel = '';
	$scope.airportTransferTypeChange = function() { 
		switch ( $rootScope.registrationData.airport_transfer_type ) {
			case 'mezzi_propri':
				$rootScope.registrationData.airport_transfer_preference = '';
			break;
			case 'aereo':
				$rootScope.transferAirportPlaceLabel = 'aeroporto';
			break;
			case 'treno':
				$rootScope.transferAirportPlaceLabel = 'stazione';
			break;
		}

	};

	$rootScope.transferLabel = '';
	$rootScope.transferPlaceLabel = '';
	$scope.transferTypeChange = function() {
		switch ( $rootScope.registrationData.transfer_type ) {
			case 'aereo':
				$rootScope.transferLabel = 'volo';
				$rootScope.transferPlaceLabel = 'aeroporto';
				break;
			case 'treno':
				$rootScope.transferLabel = 'treno';
				$rootScope.transferPlaceLabel = 'stazione';
				break;
		}
	};

	$scope.saveInvitation = function() {
		saveInvitation();
	};


	$scope.saveNotConfirm = function() {
		$rootScope.registrationData.hash   = $rootScope.invitationData.hash;
		$rootScope.registrationData.status = 'canceled';

		saveInvitation();
	};


	$scope.checkFilterList = function( invitationListIds ) {

		if ( !invitationListIds || invitationListIds.length === 0 ) return true;

		var listValid = false;
		angular.forEach(invitationListIds, function(invitationListId, key) {
			listValid = listValid || ( parseInt( invitationListId ) === parseInt( $rootScope.invitationData ? $rootScope.invitationData.invitation_list_id : 0 ) );
		});

		return listValid
	}

});